import React from 'react';
import { withRouter } from 'react-router-dom';
import { OrderIcon, FlexBox, ClickableBox } from '../Components';
import AppContext from '../AppContext';
import { routes } from '../routes';

const CurrentOrderButton = withRouter(({ history }) => (
    <AppContext.Consumer>
      {() => (
        <>
          <ClickableBox onClick={() => history.push(routes.currentOrder)}>
            <FlexBox>
              <OrderIcon />
            </FlexBox>
          </ClickableBox>
        </>
      )}
    </AppContext.Consumer>
));

export default CurrentOrderButton;
